import { defineMessages } from 'react-intl-next';

export const messages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	greeting: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	greeting: {
		id: 'twc.xflow.modal.welcome.greetingName',
		defaultMessage: 'Hi {name}!',
		description: 'Welcome screen greeting with user name',
	},
	heading: {
		id: 'twc.xflow.modal.welcome.heading',
		defaultMessage: 'Welcome to Teamwork Collection',
		description: 'Heading for the welcome screen',
	},
	description: {
		id: 'twc.xflow.modal.welcome.description',
		defaultMessage:
			"You've unlocked a smarter way for your team to connect, collaborate, and get more done.",
		description: 'Description text for the welcome screen',
	},
});
